import firebase, {
  doCreateUserWithEmailAndPassword,
  firestore,
  storage,
  onAuthStateChanged,
  doSignInWithGoogle,
  doSignInWithFacebook,
  doSignInWithEmailAndPassword,
  getLawyersLanding,
  doSignOut, getPagingNotifications, getPagingMessages, getPagingOpinions, getBillingLaywer, verifyAuthUser, updateRoleAuthUser, updateRoleAuthUserClient, updateCheckCommunity, getMenuNotifications 
} from '../../configs/environments/firebase/firebaseApp';
import * as moment from 'moment';
import { MEMBERSHIP } from '../../routes';
import axios from 'axios';

// - Constants
export const AUTH_GOOGLE_CLIENT = 'AUTH_GOOGLE_CLIENT';
export const AUTH_GOOGLE_CLIENT_FAILURE = 'AUTH_GOOGLE_CLIENT_FAILURE';
export const SIGNUP_CLIENT = 'SIGNUP_CLIENT';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const VERIFY_REQUEST = 'VERIFY_REQUEST';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const MESSAGE_LOAD = 'MESSAGE_LOAD';
export const AUTH_USER = 'AUTH_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const SIGN_OUT_USER = 'SIGN_OUT_USER';
export const AUTH_FB_CLIENT = 'AUTH_FB_CLIENT';
export const AUTH_FORM_ABOUT = 'AUTH_FORM_ABOUT';
export const AUTH_FORM_ABOUT_FIRM = 'AUTH_FORM_ABOUT_FIRM';
export const LOOK_SUCCESS = 'LOOK_SUCCESS';
export const DELETE_PICTURE_PROFILE_SUCCESS = 'DELETE_PICTURE_PROFILE_SUCCESS';
export const AUTH_FORM_EXPERIENCE = 'AUTH_FORM_EXPERIENCE';
export const ADD_EDUCATION_SUCCESS = 'ADD_EDUCATION_SUCCESS';
export const EDIT_EDUCATION_SUCCESS = 'EDIT_EDUCATION_SUCCESS';
export const DELETE_EDUCATION_SUCCESS = 'DELETE_EDUCATION_SUCCESS';
export const ADD_COURSES_SUCCESS = 'ADD_COURSES_SUCCESS';
export const EDIT_COURSES_SUCCESS = 'EDIT_COURSES_SUCCESS';
export const DELETE_COURSES_SUCCESS = 'DELETE_COURSES_SUCCESS';
export const AUTH_FORM_COMMUNITY = 'AUTH_FORM_COMMUNITY';
export const RESPONSE_TIME_COMMUNITY = 'RESPONSE_TIME_COMMUNITY';
export const GET_RECENT_ANSWERS = 'GET_RECENT_ANSWERS';
export const PROVIDE_LAWFIRM_DATA = "PROVIDE_LAWFIRM_DATA";

export const ADD_CERTIFICATION_SUCCESS = 'ADD_CERTIFICATION_SUCCESS';
export const EDIT_CERTIFICATION_SUCCESS = 'EDIT_CERTIFICATION_SUCCESS';
export const DELETE_CERTIFICATION_SUCCESS = 'DELETE_CERTIFICATION_SUCCESS';

export const ADD_AWARD_SUCCESS = 'ADD_AWARD_SUCCESS';
export const EDIT_AWARD_SUCCESS = 'EDIT_AWARD_SUCCESS';
export const DELETE_AWARD_SUCCESS = 'DELETE_AWARD_SUCCESS';

export const ADD_PUBLICATION_SUCCESS = 'ADD_PUBLICATION_SUCCESS';
export const EDIT_PUBLICATION_SUCCESS = 'EDIT_PUBLICATION_SUCCESS';
export const DELETE_PUBLICATION_SUCCESS = 'DELETE_PUBLICATION_SUCCESS';

export const ADD_LABORAL_SUCCESS = 'ADD_LABORAL_SUCCESS';
export const EDIT_LABORAL_SUCCESS = 'EDIT_LABORAL_SUCCESS';
export const DELETE_LABORAL_SUCCESS = 'DELETE_LABORAL_SUCCESS';

export const ADD_SPECIALTY_SUCCESS = 'ADD_SPECIALTY_SUCCESS';
export const EDIT_SPECIALTY_SUCCESS = 'EDIT_SPECIALTY_SUCCESS';
export const DELETE_SPECIALTY_SUCCESS = 'DELETE_SPECIALTY_SUCCESS';

export const ADD_HOLDER_SUCCESS = 'ADD_HOLDER_SUCCESS';
export const EDIT_HOLDER_SUCCESS = 'EDIT_HOLDER_SUCCESS';
export const DELETE_HOLDER_SUCCESS = 'DELETE_HOLDER_SUCCESS';
export const ADD_LAWYER_SUCCESS = 'ADD_LAWYER_SUCCESS';
export const EDIT_LAWYER_SUCCESS = 'EDIT_LAWYER_SUCCESS';
export const DELETE_LAWYER_SUCCESS = 'DELETE_LAWYER_SUCCESS';
export const ADD_INFO_SUCCESS = 'ADD_INFO_SUCCESS';
export const ADD_SOCIAL_NETWORKS_SUCCESS = 'ADD_SOCIAL_NETWORKS_SUCCESS';

export const ADD_SEDE_SUCCESS = 'ADD_SEDE_SUCCESS';
export const EDIT_SEDE_SUCCESS = 'EDIT_SEDE_SUCCESS';
export const DELETE_SEDE_SUCCESS = 'DELETE_SEDE_SUCCESS';
export const OPINIONS_LOAD = 'OPINIONS_LOAD';
export const NOTIFICATION_LOAD = 'NOTIFICATION_LOAD';
export const NOTIFICATION_MENU_LOAD = 'NOTIFICATION_MENU_LOAD';

export const SCHEDULE_SAVED = 'SCHEDULE_SAVED';
export const SCHEDULE_DELETED = 'SCHEDULE_DELETED';
export const ADD_COST_SUCCESS = 'ADD_COST_SUCCESS';
export const DELETE_PICTURE_SUCCESS = 'DELETE_PICTURE_SUCCESS';

export const ADD_VIDEO_SUCCESS = 'ADD_VIDEO_SUCCESS';
export const DELETE_VIDEO_SUCCESS = 'DELETE_VIDEO_SUCCESS';
export const AUTH_FORM_TITULAR = 'AUTH_FORM_TITULAR';
export const UPDATE_IMG_PHOTOS = 'UPDATE_IMG_PHOTOS';

export const UPDATE_LAWYER_MENU_NOTIFICATION = 'UPDATE_LAWYER_MENU_NOTIFICATION';
export const UPDATE_LAWYER_PAGE_NOTIFICATION = 'UPDATE_LAWYER_PAGE_NOTIFICATION';
export const UPDATE_NOTIFICATIONSLAW = 'UPDATE_NOTIFICATIONSLAW';

export const NOTIFICATION_READED = 'NOTIFICATION_READED';
export const NOTIFICATION_DELETED = 'NOTIFICATION_DELETED';
export const NOTIFICATION_RESTARTED = 'NOTIFICATION_RESTARTED';
export const MESSAGE_DELETED = 'MESSAGE_DELETED';
export const MESSAGE_READED = 'MESSAGE_READED';
export const MESSAGE_SAVED = 'MESSAGE_SAVED';
export const CONTACT_DELETED = 'CONTACT_DELETED';
export const OPINION_DELETED = 'OPINION_DELETED';

export const SET_SHARE_TROPHIE = 'SET_SHARE_TROPHIE';
export const UPDATE_QUALIFICATION = 'UPDATE_QUALIFICATION';

export const ANALYTICS_MESSAGE_LOAD = 'ANALYTICS_MESSAGE_LOAD';
export const ANALYTICS_OPINION_LOAD = 'ANALYTICS_OPINION_LOAD';
export const ANALYTICS_VIEWPROFILE_LOAD = 'ANALYTICS_VIEWPROFILE_LOAD';

export const ANALYTICS_MAIL_LOAD = 'ANALYTICS_MAIL_LOAD';
export const ANALYTICS_PHONE_LOAD = 'ANALYTICS_PHONE_LOAD';
export const ANALYTICS_WEB_LOAD = 'ANALYTICS_WEB_LOAD';
export const ANALYTICS_WHATSAPP_LOAD = 'ANALYTICS_WHATSAPP_LOAD';
export const ANALYTICS_MEDIOS_LOAD = 'ANALYTICS_MEDIOS_LOAD';
export const NOTIFICATION_PAGE_LOAD = 'NOTIFICATION_PAGE_LOAD';

export const UPDATE_CLIENT_DATA = 'UPDATE_CLIENT_DATA';
export const UPDATE_CLIENT_DATA_SOCIAL = 'UPDATE_CLIENT_DATA_SOCIAL';
export const UPDATE_CLIENT_PHONE_NUMBER = 'UPDATE_CLIENT_PHONE_NUMBER';
export const MEMBERSHIP_DATA = 'MEMBERSHIP_DATA';
export const UPDATE_MEMBERSHIP = 'UPDATE_MEMBERSHIP';
export const ADD_NEW_CARD = 'ADD_NEW_CARD';
export const BILLING_LAYWERS = 'BILLING_LAYWERS';
export const TYPE_VERIFY_USER = 'TYPE_VERIFY_USER';
export const ADD_TITULAR_PREMIUM_SUCCESS = 'ADD_TITULAR_PREMIUM_SUCCESS';
export const SET_BROWSER_LOCATION = 'SET_BROWSER_LOCATION';
export const SET_LANDING_LAWYERS = 'SET_LANDING_LAWYERS';
export const SHOW_MODAL_NEW_TERMS = "SHOW_MODAL_NEW_TERMS";
export const CHANGING_TERMS = "CHANGING_TERMS";


// - Action
const signUpGoogle = (data) => {
  return {
    type: AUTH_GOOGLE_CLIENT,
    payload: data,
  };
};

const signUpFacebook = (data) => {
  return {
    type: AUTH_FB_CLIENT,
    payload: data,
  };
};

const signUpGoogleError = () => {
  return {
    type: AUTH_GOOGLE_CLIENT_FAILURE,
  };
};

const signUpCredentianls = () => {
  return {
    type: AUTH_GOOGLE_CLIENT_FAILURE,
  };
};

const showingTerms = data => {
  return {
    type: SHOW_MODAL_NEW_TERMS, 
    data,
  };
}

const changingTerms = data => {
  return {
    type: CHANGING_TERMS, 
    data,
  };
}

const requestLogin = () => {
  return {
    type: LOGIN_REQUEST,
  };
};

const receiveLogin = (user) => {
  return {
    type: LOGIN_SUCCESS,
    user,
  };
};

const provideLawFirmData = (data) => {
  return {
    type: PROVIDE_LAWFIRM_DATA, 
    data,
  };
}

const formLook = (data) => {
  return {
    type: LOOK_SUCCESS,
    data,
  };
};

const profileImageDeleted = (data, boolValues) => {
  return {
    type: DELETE_PICTURE_PROFILE_SUCCESS,
    data,
    boolValues,
  };
};

const updateClientData = (data) => {
  return {
    type: UPDATE_CLIENT_DATA,
    data,
  }
}

const updateClientDataSocial = (data) => {
  return {
    type: UPDATE_CLIENT_DATA_SOCIAL,
    data,
  }
}

const updateClientPhone = (data) => {
  return {
    type: UPDATE_CLIENT_PHONE_NUMBER,
    data,
  }
}

const formAddCertification = (data, boolValues) => {
  return {
    type: ADD_CERTIFICATION_SUCCESS,
    data,
    boolValues,
  };
};

const formEditCertification = (data, boolValues) => {
  return {
    type: EDIT_CERTIFICATION_SUCCESS,
    data,
    boolValues,
  };
};

const formDeleteCertification = (data, boolValues) => {
  return {
    type: DELETE_CERTIFICATION_SUCCESS,
    data,
    boolValues,
  };
};

const formAddAward = (data, boolValues) => {
  return {
    type: ADD_AWARD_SUCCESS,
    data,
    boolValues,
  };
};

const formEditAward = (data, boolValues) => {
  return {
    type: EDIT_AWARD_SUCCESS,
    data,
    boolValues,
  };
};

const formDeleteAward = (data, boolValues) => {
  return {
    type: DELETE_AWARD_SUCCESS,
    data,
    boolValues,
  };
};

const formAddPublication = (data, boolValues) => {
  return {
    type: ADD_PUBLICATION_SUCCESS,
    data,
    boolValues,
  };
};

const formEditPublication = (data, boolValues) => {
  return {
    type: EDIT_PUBLICATION_SUCCESS,
    data,
    boolValues,
  };
};

const formDeletePublication = (data, boolValues) => {
  return {
    type: DELETE_PUBLICATION_SUCCESS,
    data,
    boolValues,
  };
};

const formAddLaboral = (data, boolValues) => {
  return {
    type: ADD_LABORAL_SUCCESS,
    data,
    boolValues,
  };
};

const formEditLaboral = (data, boolValues) => {
  return {
    type: EDIT_LABORAL_SUCCESS,
    data,
    boolValues,
  };
};

const formDeleteLaboral = (data, boolValues) => {
  return {
    type: DELETE_LABORAL_SUCCESS,
    data,
    boolValues,
  };
};

const formAddSpecialty = (data, boolValues) => {
  return {
    type: ADD_SPECIALTY_SUCCESS,
    data,
    boolValues,
  };
};

const formEditSpecialty = (data, boolValues) => {
  return {
    type: EDIT_SPECIALTY_SUCCESS,
    data,
    boolValues,
  };
};

const formDeleteSpecialty = (data, boolValues) => {
  return {
    type: DELETE_SPECIALTY_SUCCESS,
    data,
    boolValues,
  };
};

const formAddHolder = (data, boolValues) => {
  return {
    type: ADD_HOLDER_SUCCESS,
    data,
    boolValues,
  };
};

const formEditHolder = (data, boolValues) => {
  return {
    type: EDIT_HOLDER_SUCCESS,
    data,
    boolValues,
  };
};

const formTitularPremium = (data, email,info) => {
  return {
    type: ADD_TITULAR_PREMIUM_SUCCESS,
    data,
    email,
    info
  };
};

const formDeleteHolder = (data, boolValues) => {
  return {
    type: DELETE_HOLDER_SUCCESS,
    data,
    boolValues,
  };
};

const formAddLawyer = (data, boolValues) => {
  return {
    type: ADD_LAWYER_SUCCESS,
    data,
    boolValues,
  };
};

const formEditLawyer = (data, boolValues) => {
  return {
    type: EDIT_LAWYER_SUCCESS,
    data,
    boolValues,
  };
};

const formDeleteLawyer = (data, boolValues) => {
  return {
    type: DELETE_LAWYER_SUCCESS,
    data,
    boolValues,
  };
};

const formDeletePictures = (data, boolValues) => {
  return {
    type: DELETE_PICTURE_SUCCESS,
    data,
    boolValues,
  };
};

const formVideoYoutube = (data, boolValues) => {
  return {
    type: ADD_VIDEO_SUCCESS,
    data,
    boolValues,
  };
};

const membershipData = (data) => {
  return {
    type: MEMBERSHIP_DATA,
    data,
  };
};

const formDeleteVideoYoutube = (data, boolValues) => {
  return {
    type: DELETE_VIDEO_SUCCESS,
    data,
    boolValues,
  };
};

const aditionProfile = (data, boolValues) => {
  return {
    type: ADD_INFO_SUCCESS,
    data,
    boolValues,
  };
};

const addSocialNetworks = (data, boolValues) => {
  return {
    type: ADD_SOCIAL_NETWORKS_SUCCESS,
    data,
    boolValues,
  };
};

const sedeProfile = (data, boolValues) => {
  return {
    type: ADD_SEDE_SUCCESS,
    data,
    boolValues,
  };
};

const sedeProfileEdit = (data, boolValues) => {
  return {
    type: EDIT_SEDE_SUCCESS,
    data,
    boolValues,
  };
};

const formDeleteSede = (data, boolValues) => {
  return {
    type: DELETE_SEDE_SUCCESS,
    data,
    boolValues,
  };
};

const saveSchedule = (data, boolValues, typeSchedule) => {
  return {
    type: SCHEDULE_SAVED,
    data,
    boolValues,
    typeSchedule
  }
}

const scheduleDeleted = (data, boolValues) => {
  return {
    type: SCHEDULE_DELETED,
    data,
    boolValues,
  }
}

const updateImgPhotos = (data, boolValues) => {
  return {
    type: UPDATE_IMG_PHOTOS,
    data,
    boolValues,
  };
};

const costProfile = (data, boolValues) => {
  return {
    type: ADD_COST_SUCCESS,
    data,
    boolValues,
  };
};

const formEducationLawyer = (data, boolValues) => {
  return {
    type: ADD_EDUCATION_SUCCESS,
    data,
    boolValues,
  }
}

const formEditEducation = (data, boolValues) => {
  return {
    type: EDIT_EDUCATION_SUCCESS,
    data,
    boolValues,
  }
}

const formDeleteEducationItem = (data, boolValues) => {
  return {
    type: DELETE_EDUCATION_SUCCESS,
    data,
    boolValues,
  }
}

const formCoursesLawyer = (data, boolValues) => {
  return {
    type: ADD_COURSES_SUCCESS,
    data,
    boolValues,
  }
}

const formEditCourses = (data, boolValues) => {
  return {
    type: EDIT_COURSES_SUCCESS,
    data,
    boolValues,
  }
}

const formDeleteCoursesItem = (data, boolValues) => {
  return {
    type: DELETE_COURSES_SUCCESS,
    data,
    boolValues,
  }
}
const membershipInfo = (data) => {
  return {
    type: UPDATE_MEMBERSHIP,
    data,
  }
}




const loginError = () => {
  return {
    type: LOGIN_FAILURE,
  };
};

const requestLogout = () => {
  return {
    type: LOGOUT_REQUEST,
  };
};

const receiveLogout = () => {
  return {
    type: LOGOUT_SUCCESS,
  };
};

const logoutError = () => {
  return {
    type: LOGOUT_FAILURE,
  };
};
const messageLawLoad = (data) => {
  return {
    type: MESSAGE_LOAD,
    data,
  };
};

const notificationPagesLoad = (data) => {
  return {
    type: NOTIFICATION_PAGE_LOAD,
    data
  }
}
const menuNotificationsLoad = (data) => {
  return {
    type: NOTIFICATION_MENU_LOAD,
    data
  }
}

const opinionsLawLoad = (data) => {
  return {
    type: OPINIONS_LOAD,
    data,
  };
};

const analyticsMessage = (data) => {
  return {
    type: ANALYTICS_MESSAGE_LOAD,
    data,
  };
};

const analyticsOpinion = (data) => {
  return {
    type: ANALYTICS_OPINION_LOAD,
    data,
  };
};

const analyticsViewProfile = (data) => {
  return {
    type: ANALYTICS_VIEWPROFILE_LOAD,
    data,
  };
};

const analyticsMail = (data) => {
  return {
    type: ANALYTICS_MAIL_LOAD,
    data,
  };
};

const analyticsPhone = (data) => {
  return {
    type: ANALYTICS_PHONE_LOAD,
    data,
  };
};

const analyticsWeb = (data) => {
  return {
    type: ANALYTICS_WEB_LOAD,
    data,
  };
};

const analyticsWhatsApp = (data) => {
  return {
    type: ANALYTICS_WHATSAPP_LOAD,
    data,
  };
};
const analyticsMedios = (data) => {
  return {
    type: ANALYTICS_MEDIOS_LOAD,
    data,
  };
};

const updateLawyerMenuNotifications = (data) => {
  return {
    type: UPDATE_LAWYER_MENU_NOTIFICATION,
    data
  }
}

const updateLawyerPageNotifications = (data) => {
  return {
    type: UPDATE_LAWYER_PAGE_NOTIFICATION,
    data
  }
}
const updateNotificationsLaw = (data) => {
  return {
    type: UPDATE_NOTIFICATIONSLAW,
    data
  }
}
const notificationsLawLoad = (data) => {
  return {
    type: NOTIFICATION_LOAD,
    data,
  };
};

const notificationReaded = (data) => {
  return {
    type: NOTIFICATION_READED,
    data,
  };
};

const notificationRestarted = (data) => {
  return {
    type: NOTIFICATION_RESTARTED,
    data,
  };
};

const messageReaded = (data) => {
  return {
    type: MESSAGE_READED,
    data,
  };
};

const messageSaved = (data) => {
  return {
    type: MESSAGE_SAVED,
    data,
  };
};

const notificationDeleted = (data) => {
  return {
    type: NOTIFICATION_DELETED,
    data,
  };
};

const messageDeleted = (data) => {
  return {
    type: MESSAGE_DELETED,
    data,
  };
};

const opinionDeleted = (data) => {
  return {
    type: OPINION_DELETED,
    data,
  };
};

const contactDeleted = (data) => {
  return {
    type: CONTACT_DELETED,
    data,
  };
};

const verifyRequest = () => {
  return {
    type: VERIFY_REQUEST,
  };
};

const verifySuccess = () => {
  return {
    type: VERIFY_SUCCESS,
  };
};

const authUser = (data) => {
  return {
    type: AUTH_USER,
    data,
  };
};

const authFormAbout = (data, boolValues) => {
  return {
    type: AUTH_FORM_ABOUT,
    data,
    boolValues,
  };
};
const authFormAboutFirm = (data, boolValues) => {
  return {
    type: AUTH_FORM_ABOUT_FIRM,
    data,
    boolValues,
  };
};

const authFormTitular = (data, boolValues) => {
  return {
    type: AUTH_FORM_TITULAR,
    data,
    boolValues
  };
};

const authFormExperience = (data, boolValues) => {
  return {
    type: AUTH_FORM_EXPERIENCE,
    data,
    boolValues,
  };
};

const authFormCommunity = (data) => {
  return {
    type: AUTH_FORM_COMMUNITY,
    data
  };
};

const responseTimeCommunity = (data) => {
  return {
    type: RESPONSE_TIME_COMMUNITY,
    data
  };
};

const gettingRecentAnswers = (data) => {
  return {
    type: GET_RECENT_ANSWERS,
    data
  };
};

const updateHighQualification = (data) => {
  return {
    type: UPDATE_QUALIFICATION,
    data,
  }
}

const authError = (error) => {
  return {
    type: AUTH_ERROR,
    payload: error,
  };
};

const signOutUser = () => {
  return {
    type: SIGN_OUT_USER,
  };
};

const shareTrophie = (data) => {
  return {
    type: SET_SHARE_TROPHIE,
    data,
  }
}
const addNewCard = (data) => {
  return {
    type: ADD_NEW_CARD,
    data,
  }
}

const billingLaywer = (data) => {
  return {
    type: BILLING_LAYWERS,
    data
  }
}

const typeUser = (data) => {
  return {
    type: TYPE_VERIFY_USER,
    data,
  };
};

const browserLocation = (data) => {
  return {
    type: SET_BROWSER_LOCATION,
     data
  };
};

const browserLandingLawyers = (data) => {
  return {
    type: SET_LANDING_LAWYERS,
    data
  };
};


/* charlywaffless240 */

// - Thunks
/* export const signUpGoogleClient = (userAuth, additionalData) => async dispatch => {
  
  if(!userAuth) return;
  dispatch(signUpGoogle(userAuth));
  const userRef = firestore.doc(`client/${userAuth.uid}`);
  const snapShot = await userRef.get();
  if(!snapShot.exists){
    const { displayName, email } = userAuth;
    const createAt = new Date()
    try {
      await userRef.set({
        displayName,
        email,
        createAt,
        ...additionalData
      })
    } catch (error) {
      
    }
  }
  return userRef;
}
onAuthStateChangedClient = () =>{
  this.auth.onAuthStateChanged(async userAuth =>{
    if(userAuth){
      const userRef = await this.createUserProfileDocument(userAuth);
      userRef.onSnapshot(snapShot =>{
        return({
          ...snapShot.data(),
          id: snapShot.id,
        })
       
      })
    }else{
      return userAuth
    }
    
    
  });
}
createUserProfileDocument = async (userAuth, additionalData)=> {
  if(!userAuth) return;
  
  const userRef = this.firestore.doc(`client/${userAuth.uid}`);
  const snapShot = await userRef.get();
  if(!snapShot.exists){
    const { displayName, email } = userAuth;
    const createAt = new Date()
    try {
      await userRef.set({
        displayName,
        email,
        createAt,
        ...additionalData
      })
    } catch (error) {
      
    }
  }
  return userRef;
}
 */

export const signUpFacebookCreator = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    doSignInWithFacebook()
      .then((res) => {
        const additionalData = {
          registeredSocial: 'FACEBOOK',
          uid: res.user.uid,
        };
        onAuthStateChanged(additionalData);
        updateRoleAuthUserClient(res.user.uid).then((update) => {
        }).catch((error) => {
        });
        dispatch(authUser(res));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const signUpGoogleCreator = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    doSignInWithGoogle()
      .then((res) => {
        const additionalData = {
          registeredSocial: 'GOOGLE',
          uid: res.user.uid
        };
        onAuthStateChanged(additionalData);
        updateRoleAuthUserClient(res.user.uid).then((update) => {
        }).catch((error) => {
        });
        dispatch(authUser(res));
        return resolve(res);
      })
      .catch((err) => reject(err));

  });

};

export const signUpUser = (email, password, profile) => (dispatch) => {
  const {
    phone,
    specialties,
    termsAndConditions,
    role,
    name,
    officeName,
    firstLastName,
    secondLastName,
    gender,
    email,
  } = profile;
  return new Promise((resolve, reject) => {
    doCreateUserWithEmailAndPassword(email, password)
      .then((data) => {
        const createAt = new Date();
        if (data.user.uid) {
          let user = {};
          if (officeName) {
            user = {
              active: true,
              uid: data.user.uid,
              email: email,
              officeName,
              specialtiesTitular: [],
              name,
              community: true,
              firstLastName,
              secondLastName,
              genero: gender,
              phone,
              specialties: [specialties],
              termsAndConditions,
              role,
              createAt,
              membership: {
                type: 'Freemium',
                oldType: 'Free',
                timeMembership: createAt,
              },
              statusMembership: "inactive",
              awardPerfil: {
                look: false,
                about: false,
                experience: false,
                contact: false,
                community: true
              },
              awardAditional: {
                cost: false,
                pictures: false,
                videos: false,
                shareProfile: false,
                highQualification: false,
              },
              analytics: {
                formProfile: 0,
                viewProfile: 0,
                opinion: {
                  counts: 0,
                  qualification: 0,
                },
                contact: {
                  whatsApp: 0,
                  phone: 0,
                  web: 0,
                  email: 0,
                },
              },
            };
          } else {
            user = {
              active: true,
              uid: data.user.uid,
              email: email,
              name,
              community: true,
              firstLastName,
              secondLastName,
              genero: gender,
              phone,
              specialties: [specialties],
              termsAndConditions,
              role,
              createAt,
              membership: {
                type: 'Freemium',
                oldType: 'Free',
                timeMembership: createAt,
              },
              statusMembership: "inactive",
              awardPerfil: {
                look: false,
                about: false,
                experience: false,
                contact: false,
                community: true,
              },
              awardAditional: {
                cost: false,
                pictures: false,
                videos: false,
                shareProfile: false,
                highQualification: false,
              },
              analytics: {
                formProfile: 0,
                viewProfile: 0,
                opinion: {
                  counts: 0,
                  qualification: 0,
                },
                contact: {
                  whatsApp: 0,
                  phone: 0,
                  web: 0,
                  email: 0,
                },
              },
            };
          }

          firestore.collection('lawyerUsers').doc(data.user.uid).set(user);
          updateCheckCommunity('active').then((community) => {
          }).catch((error) => {
          });
          updateRoleAuthUser(data.user.uid).then((update) => {
          }).catch((error) => {
          });
          dispatch(authUser(user));
          return resolve(user);
        }
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const provideData = idLawFirm => dispatch => {
  return new Promise(() => {
    firestore
      .collection("lawyerUsers").doc(idLawFirm)
      .get()
      .then(doc => {
        dispatch(provideLawFirmData(doc.data()))
      })
      .catch(error=>{})
  })
}

export const aboutForm = (data, uid, boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let {
      name,
      firstLastName,
      secondLastName,
      // specialties,
      phone,
      colegNumber = '',
      cedula = '',
      expYears = '',
      languages = [],
      officeName = '',
      gradeStudy = '',
    } = data;
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set(
        {
          name,
          firstLastName,
          secondLastName,
          phone,
          // specialties,
          cedula,
          expYears,
          colegNumber,
          languages,
          awardPerfil: {
            about: boolValues,
          },
          gradeStudy,
          officeName,
        },
        { merge: true }
      )
      .then((res) => {
        dispatch(authFormAbout(data, boolValues));
        return resolve(res);
      })
      .catch((err) => {
        reject(err)
      });
  });
};

export const aboutFirmForm = (data, uid, boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        ...data,
        awardPerfil: {
          about: boolValues
        }
      },
        { merge: true }
      )
      .then((res) => {
        dispatch(authFormAboutFirm(data, boolValues));
        return resolve(res);
      })
      .catch((err) => {
        reject(err)
      });
  });
};

export const updatePersonalDataClient = (uid, values) => dispatch => {
  return new Promise((resolve, reject) => {
    firestore.collection("client")
      .doc(uid)
      .update({
        "name": values.name,
        "lastName": values.lastName,
      })
      .then((res) => {
        dispatch(updateClientData(values));
        return resolve(res);
      })
      .catch((err) => reject(err));
  })
}

export const updatePersonalDataClientSocial = (uid, values) => dispatch => {
  return new Promise((resolve, reject) => {
    const displayName = `${values.name} ${values.lastName}`
    firestore.collection("client")
      .doc(uid)
      .set({
        displayName,
        name: values.name,
        lastName: values.lastName
      }, { merge: true })
      .then((res) => {
        values["displayName"] = displayName
        dispatch(updateClientDataSocial(values));
        return resolve(res);
      })
      .catch((err) => reject(err));
  })
}

export const updatePhoneNumberClient = (uid, phone) => dispatch => {
  return new Promise((resolve, reject) => {
    firestore.collection("client")
      .doc(uid)
      .update({
        phone,
      })
      .then((res) => {
        dispatch(updateClientPhone(phone));
        return resolve(res);
      })
      .catch((err) => reject(err));
  })
}

export const updateQualification = (uid, boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set(
        {
          awardAditional: {
            highQualification: boolValues,
          }
        },
        { merge: true }
      )
      .then((res) => {
        dispatch(updateHighQualification(boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  })
}

export const titularForm = (data, uid, imgProfileTitular, boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let {
      name,
      firstLastName,
      secondLastName,
      nameUniversity = '',
      specialtiesTitular,
      cedula = '',
      awards = '',
      expYears = '',
      gradeStudy = '',
      experienceTitutar = '',
      genero = '',
    } = data;
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set(
        {
          name,
          firstLastName,
          secondLastName,
          genero,
          specialtiesTitular,
          cedula,
          awards,
          expYears,
          nameUniversity,
          gradeStudy,
          experienceTitutar,
          imgProfileTitular: imgProfileTitular,
          awardPerfil: {
            holder: boolValues,
          }
        },
        { merge: true }
      )
      .then((res) => {
        dispatch(authFormTitular(data, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const experienceForm = (experience, uid, boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        experience,
        awardPerfil: {
          experience: boolValues
        }
      }, { merge: true })
      .then((res) => {
        dispatch(authFormExperience(experience, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const communityForm = (community, uid) => (dispatch) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        community,
        awardPerfil: {
          community: community
        }
      }, { merge: true })
      .then((res) => {
        dispatch(authFormCommunity(community));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};



export const responseTimeInCommunity = lawyerUid => dispatch => {

  const getWordCount = timeResponse => {
    let map = {};
    if (
      timeResponse &&
      timeResponse.length
      ) {
      for (let i = 0; i < timeResponse.length; i++) {
        let item = timeResponse[i];
        map[item] = (map[item] + 1) || 1;
      }
    }
    return map;
  }
  
  const sortingArray = counter => {
    let sortedArray = []
    for (let i = 0; i < counter.fast; i++) {
      sortedArray.push('fast')
    }
    for (let i = 0; i < counter.mid; i++) {
      sortedArray.push('mid')
    }
    for (let i = 0; i < counter.low; i++) {
      sortedArray.push('low')
    }
    return sortedArray
  }

  return new Promise(async (resolve, reject) => {
    try {
      const querySnapshot = await firestore
        .collectionGroup('response')
        .orderBy('createdAt', 'desc')
        .where(
          'uidLawyerUsers', '==', lawyerUid
        )
        .get()
      let timeResponse = []
      const data = await querySnapshot.docs.map(async (doc) => {
        let timestamps = {
          timeAnswer: doc.data().createdAt
        }
        if (doc.data() && doc.data().idQuestion) {
          const idQuestion = doc.data().idQuestion
          try {
            const elem = await firestore
              .collection("questions").doc(idQuestion)
              .get()
            timestamps['timeQuestion'] = elem.data().createdAt
            const ms = moment(timestamps.timeQuestion.seconds)
              .diff(moment(timestamps.timeAnswer.seconds));
            const d = moment.duration(ms);
            const hours = d.asHours()
            const absoluteValue = Math.abs(hours * 1000)
            
            if (absoluteValue < 24) {
              timeResponse.push('fast')
            } else if (absoluteValue >= 24 && absoluteValue < 36) {
              timeResponse.push('mid')
            } else if (absoluteValue >= 36) {
              timeResponse.push('low')
            }

            return timeResponse
          } catch (error) {
            reject(error)
          }
        }
      })
      const res = await Promise.all(data)
      const counter = getWordCount(res[0])
      const sortedArray = sortingArray(counter)
      const index = Math.floor(sortedArray.length / 2)
      const result = sortedArray[index]

      await firestore
        .collection('lawyerUsers')
        .doc(lawyerUid)
        .set({
          responseTime: result ? result : null
        }, { merge: true })

      dispatch(responseTimeCommunity(result))
      resolve(res[0])
    } catch (error) {
      reject(error)
    }
  })
}

export const getRecentAnswers = lawyerUid => dispatch => {
  return new Promise(async (resolve, reject) => {
    const querySnapshot = await firestore
        .collectionGroup('response')
        .orderBy('createdAt', 'desc')
        .where(
          'uidLawyerUsers', '==', lawyerUid
        )
        .get()
      let questionsArray = []
      const data = await querySnapshot.docs.map(async (doc) => {
        if (doc.data() && doc.data().idQuestion) {
          const idQuestion = doc.data().idQuestion
          try {
            const elem = await firestore
              .collection("questions").doc(idQuestion)
              .get()
            questionsArray.push(elem.data())
            return questionsArray
          } catch (error) {
            reject(error)
          }
        }
      })  
      
      const res = await Promise.all(data)

      let newQuestionsArray = []

      if (res && res[0]) {
        let reducedQuestions = res[0].reduce((prev, t) => {
          if (typeof prev[t.id] === 'undefined') {
            prev[t.id] = [];
          }
          prev[t.id].push(t);
          return prev;
        }, {});
        
        newQuestionsArray = Object.keys(reducedQuestions).map((elem) => {
          const newData = reducedQuestions[elem][0];
          return newData
        });
      }

      dispatch(gettingRecentAnswers(newQuestionsArray))
      resolve(newQuestionsArray)
  })
}

export const changeToCourtesyLawyer = (userResponse) => dispatch => {
  let user = userResponse
  user['roleAuth'] = 'lawyeruser'
  dispatch(receiveLogin(user))
}

export const loginUser = (email, password, typeLogin) => (dispatch) => {
  dispatch(requestLogin());
  return new Promise((resolve, reject) => {
    verifyAuthUser(email).then((response) => {
      dispatch(typeUser(response))
      if (response.roleAuth == typeLogin) {
        return doSignInWithEmailAndPassword(email, password)
          .then((user) => {
            user['roleAuth'] = response.roleAuth
            dispatch(receiveLogin(user));
            return resolve(user);
          })
          .catch((error) => {
            dispatch(loginError());
            return reject(error);
          });
      } else {
        let error = {
          code: 'auth/invalid-user'
        }
        if (response.roleAuth !== typeLogin) {
          error = {
            code: 'auth/invalid-role'
          }
        }
        return reject(error)
      }
    }).catch((error) => {
      return reject(error);
    })
  });
};

export const signUpClient = (email, password, profile) => (dispatch) => {
  const { phone, termsAndConditions, name, lastName, email } = profile;
  return new Promise((resolve, reject) => {
    doCreateUserWithEmailAndPassword(email, password)
      .then((data) => {
        const createAt = new Date();
        if (data.user.uid) {
          const user = {
            email,
            uid: data.user.uid,
            phone,
            termsAndConditions,
            name,
            lastName,
            role: 'cliente',
            createAt,
          };
          firestore.collection('client')
            .doc(data.user.uid)
            .set(user);
          updateRoleAuthUserClient(data.user.uid)
            .then((update) => {})
            .catch((error) => {});
          dispatch(authUser(user));
          return resolve(user);
        }
      })
      .catch((err) => reject(err));
  });
};

export const logoutUser = () => (dispatch) => {
  dispatch(requestLogout());
  doSignOut()
    .then(() => {
      dispatch(receiveLogout());
    })
    .catch((error) => {
      //Do something with the error if you want!
      dispatch(logoutError());
    });
};

export function verifyAuth() {
  return async function (dispatch) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        firestore
          .collection('lawyerUsers')
          .doc(user.uid)
          .get()
          .then((snapshot) => {
            if (snapshot.data()) {
              let element = snapshot.data();
              dispatch(authUser({ user, ...element }));
              try {
                let uid = element && element.role === "lawyer" && element.idLawFirm && element.idLawFirm !== undefined && element.idLawFirm !== "" ? element.idLawFirm : user.uid;
                process_notificationsPage(dispatch, uid, 1, 'lawyer')
                process_menuNotifications(dispatch, uid, 'lawyer');
                // pagination 
                process_messagesPage(dispatch, user.uid, 1);
                process_opinionsPage(dispatch, user.uid, 1);
                process_notifications(dispatch, uid);
                process_analytics(dispatch, user.uid);
                process_billing(dispatch, user.uid);

                /* 
                process_membershipCards(dispatch, user.uid);
                process_membershipHistorial(dispatch, user.uid); */

              } catch (err) { }
            }
          });

        firestore
          .collection('client')
          .doc(user.uid)
          .get()
          .then((snapshot) => {
            if (snapshot.data()) {
              dispatch(authUser({ user, ...snapshot.data() }));
              try {
                process_notificationsPage(dispatch, user.uid, 1, 'client')

              } catch (err) { }
            }
          });
      } else {
        firebase.auth().signOut();

        dispatch(signOutUser());
      }
    });
  };
}
// Notificacions Process 
async function process_notificationsPage(dispatch, uid, page, type) {
  try {
    let notifications = await getPagingNotifications(uid, page, type)
    dispatch(notificationPagesLoad(notifications));
  } catch (error) {
    throw error;
  }
}

export const updateNotificationPage = (uid, page, type) => (dispatch) => {
  process_notificationsPage(dispatch, uid, page, type)
};

async function process_menuNotifications(dispatch, uid, type){
  try {
    let notifications = await getMenuNotifications(uid, type)
    dispatch(menuNotificationsLoad(notifications.data))
  }catch(error){
    throw error;
  }
}

// Messages Process 

async function process_messagesPage(dispatch, uid, page) {
  try {
    let messages = await getPagingMessages(uid, page)
    dispatch(messageLawLoad(messages));
  } catch (error) {
    throw error;
  }
}

export const updateMessagesPage = (uid, page) => (dispatch) => {
  process_messagesPage(dispatch, uid, page)
};

// Opinions Process 

async function process_opinionsPage(dispatch, uid, page) {
  try {
    let opinions = await getPagingOpinions(uid, page);
    dispatch(opinionsLawLoad(opinions));
  } catch (error) {
    throw error;
  }
}

async function process_billing(dispatch, uid) {
  try {
    let data = await getBillingLaywer(uid);
    dispatch(billingLaywer(data))

  } catch (error) {
    throw error;
  }
}




export const updateOpinionsPage = (uid, page) => (dispatch) => {
  process_opinionsPage(dispatch, uid, page)
};


// updateNotificationPage: (uid, page) => dispatch(updateNotificationPage(uid, page)),
// deleteNotificationPage: () => dispatch(deleteNotificationPage(uid, page))





async function process_tasks(dispatch, id) {
  let wholeData = [];
  let mesRef = firestore.collection('messages').doc(id).collection('message');
  let result = await mesRef
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        // doc.data() is never undefined for query doc snapshots
        wholeData.push(doc.data());
      });
    })
    .catch((error) => { });
  dispatch(messageLawLoad(wholeData));
}

async function process_notifications(dispatch, id) {
  let wholeData = [];
  let mesRef = firestore.collection('notifications').doc(id).collection('notification');

  let result = await mesRef
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        // doc.data() is never undefined for query doc snapshots
        wholeData.push(doc.data());
      });
    })
    .catch((error) => { });
  dispatch(notificationsLawLoad(wholeData));
}

async function process_opinion(dispatch, id) {
  let wholeData = [];
  let mesRef = firestore.collection('opinions').doc(id).collection('opinion');
  let result = await mesRef
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        // doc.data() is never undefined for query doc snapshots
        wholeData.push(doc.data());
      });
    })
    .catch((error) => { });
  dispatch(opinionsLawLoad(wholeData));
}


async function process_analytics(dispatch, uid) {
  let formMessage = [];
  let formOpinion = [];
  let viewProfile = [];
  let mail = [];
  let phone = [];
  let web = [];
  let whatsApp = [];
  let medio = [];



  let mesRefMessage = firestore.collection('analytics').doc(uid).collection('formMessage');
  let mesRefOpinon = firestore.collection('analytics').doc(uid).collection('formOpinion');
  let mesRefViewProfile = firestore.collection('analytics').doc(uid).collection('viewProfile');

  let mesRefMail = firestore.collection('analytics').doc(uid).collection('mail');
  let mesRefPhone = firestore.collection('analytics').doc(uid).collection('phone');
  let mesRefWeb = firestore.collection('analytics').doc(uid).collection('web');
  let mesRefWhatsApp = firestore.collection('analytics').doc(uid).collection('whatsApp');

  let resultMessage = await mesRefMessage
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        // doc.data() is never undefined for query doc snapshots
        formMessage.push(doc.data());
      });
    })
    .catch((error) => { });


  let resultOpinion = await mesRefOpinon
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        // doc.data() is never undefined for query doc snapshots
        formOpinion.push(doc.data());
      });
    })
    .catch((error) => { });

  let resultViewPro = await mesRefViewProfile
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        // doc.data() is never undefined for query doc snapshots
        viewProfile.push(doc.data());
      });
    })
    .catch((error) => { });


  let resultMail = await mesRefMail
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        mail.push(doc.data());
      });
    })
    .catch((error) => { });


  let resultPhone = await mesRefPhone
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        phone.push(doc.data());
      });
    })
    .catch((error) => { });

  let resultWeb = await mesRefWeb
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        web.push(doc.data());
      });
    })
    .catch((error) => { });


  let resultWhatsApp = await mesRefWhatsApp
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        whatsApp.push(doc.data());
      });
    })
    .catch((error) => { });


  dispatch(analyticsMessage(formMessage));
  dispatch(analyticsOpinion(formOpinion));
  dispatch(analyticsViewProfile(viewProfile));


  dispatch(analyticsMail(mail));
  dispatch(analyticsPhone(phone));
  dispatch(analyticsWeb(web));
  dispatch(analyticsWhatsApp(whatsApp));
  dispatch(analyticsMedios([...whatsApp, ...mail, ...phone, ...web]));
}


/* 
MODO DE REF
firestore
.collection('client')
.doc(user.uid)
.get()
.then(snapshot => {
  if (snapshot.data()) {
    dispatch(authUser({ user, ...snapshot.data() }));
  }
});
} else {
firebase.auth().signOut();

dispatch(signOutUser());
}
});
};
}

async function process_tasks(dispatch, id) {
let wholeData = []  
let mesRef =  firestore.collection("lawyerUsers").doc(id);



let result = await firestore.collection("messages").where("lawyer", "==", mesRef).get()
.then(querySnapshot =>{
querySnapshot.forEach(function(doc) {
// doc.data() is never undefined for query doc snapshots
wholeData.push(doc.data())
return ''
});
})
.catch(error=>{

})
dispatch(messageLawLoad(wholeData));
}

 */

export const showNewTerms = (open, role) => dispatch => {
  let isOpen = open
  if (
    !role || (role && role === 'cliente')
  ) {
    isOpen = false
  }
  dispatch(showingTerms(isOpen))
}

export const changeTerms = (value, uid) => dispatch => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
        .doc(uid)
        .set({
          termsAndConditions: value
        }, { merge: true })
        .then((res) => {
          dispatch(changingTerms(value))
          return resolve()
        })
        .catch((err) => {
          return reject(err)
        })
  })
}

export const lookAbout = (fireBaseUrl, uid, imgenPortada, achievement, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set(
        {
          imgProfile: fireBaseUrl,
          imgenPortada: imgenPortada ? imgenPortada : '',
          awardPerfil: { look: boolValues },
        },
        { merge: true }
      )
      .then((res) => {
        dispatch(
          formLook({
            imgProfile: fireBaseUrl,
            imgenPortada: imgenPortada,
            awardPerfil: { look: boolValues },
          })
        );
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* Delete profile image */
export const deleteProfileImage = (uid, pathImgItem, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {
    // Borramos imagenes de Storage
    deleteImg(uid, pathImgItem);

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        imgProfile: "",
        awardPerfil: {
          look: false,
        }
      }, { merge: true })
      .then((res) => {
        dispatch(profileImageDeleted("", boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));

  });

};

export const setimgViews = (item, uid, index, arr, boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const updatedLocations = firebase.firestore.FieldValue.arrayUnion({
      // id: `${index}`,
      src: `${item}${index}`,
    });
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        imgViews: updatedLocations,
        awardAditional: {
          pictures: boolValues
        }
      }, { merge: true })
      .then((res) => {
        dispatch(updateImgPhotos(arr, boolValues));

        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* -Eliminar del Storage la imgaen
-Eliminar del arreglo el item deseado
-Mandar el nuevo arreglo a redux
pathImgItem
 */

/* picturElem, uid, idImage, arr ,pathImgItem */
export const deleteimgViews = (item, uid, index, arr, pathImgItem, itemObj, boolValues) => (
  dispatch
) => {
  // Borramos imagenes de Storage
  /*  var imgToDelete = item.filter(function (Element, indexPhoto) {
      return indexPhoto === index;
    }); */
  deleteImg(uid, pathImgItem);

  // Creamos Arreglo que no se borrara
  /* var imgToContinue = item.filter(function (Element, indexPhoto) {
      return indexPhoto !== index;
    }); */
  // Borrando todas las imagenes

  firestore
    .collection('lawyerUsers')
    .doc(uid)
    .update({ imgViews: item })
    .then((res) => {
      dispatch(formDeletePictures(item));
    });

  firestore
    .collection('lawyerUsers')
    .doc(uid)
    .set({
      awardAditional: {
        pictures: boolValues,
      }
    }, { merge: true })
    .then((res) => {
      dispatch(formDeletePictures(item, boolValues));
    });

  /*   if (imgToContinue.length > 0) {
      imgToContinue.map((item, index) => {
        let updatedImgs = firebase.firestore.FieldValue.arrayUnion({
          src: item.pathImg,
        });
 */
  /*  firestore
          .collection('lawyerUsers')
          .doc(uid)
          .set({ imgViews: item }, { merge: true })
          .then(res => {
            dispatch(formDeletePictures({ updatedImgs }));
            return resolve(res);
          })
          .catch(err => reject(err));
      }); */
  /*  } else {
      dispatch(formDeletePictures([]));
      return resolve(true);
    } */
};



/* ------------------------------------------------------------------------------------------ */

export const addAward = (uid, values, awardsLawyer, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {

    let updatedData
    if (awardsLawyer && awardsLawyer.length !== 0) {
      updatedData = [
        ...values,
        ...awardsLawyer,
      ]
    } else {
      updatedData = [
        ...values,
      ]
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        awardsLawyer: updatedData,
        awardPerfil: {
          awardsLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formAddAward([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const editAward = (
  uid,
  values,
  awardsLawyer,
  boolValues,
) => (dispatch) => {
  return new Promise((resolve, reject) => {

    let updatedData = [
      ...awardsLawyer,
      ...values
    ]

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        awardsLawyer: updatedData,
        awardPerfil: {
          awardsLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formEditAward([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const deleteAward = (uid, index, values) => (dispatch) => {
  return new Promise((resolve, reject) => {
    if (values[index].myImageAward) {
      deleteImg(uid, values[index].myImageAward);
    }
    let AwardElems = values.filter(function (Element, ind) {
      return index !== ind;
    });

    let boolValues
    AwardElems.forEach((elem) => {
      const allValues = Object.values(elem)
      boolValues = allValues.every(elem => {
        if (elem !== '') {
          return true
        }
        return false
      })
    })

    if (!AwardElems || AwardElems.length === 0) {
      AwardElems = []
      boolValues = false
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        awardsLawyer: AwardElems,
        awardPerfil: {
          awardsLawyer: boolValues,
        }
      }, { merge: true })
      .then((res) => {
        dispatch(formDeleteAward(AwardElems, boolValues));
        return resolve(true);
      })
      .catch((error) => reject(false));

  });
};

/* ------------------------------------------------------------------------------------------ */

export const addLaboral = (uid, values, laboralsLawyer, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {

    let updatedData
    if (laboralsLawyer && laboralsLawyer.length !== 0) {
      updatedData = [
        ...values,
        ...laboralsLawyer,
      ]
    } else {
      updatedData = [
        ...values,
      ]
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        laboralsLawyer: updatedData,
        awardPerfil: {
          laboralsLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formAddLaboral([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const editLaboral = (
  uid,
  values,
  laboralsLawyer,
  boolValues,
) => (dispatch) => {
  return new Promise((resolve, reject) => {

    let updatedData = [
      ...laboralsLawyer,
      ...values
    ]

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        laboralsLawyer: updatedData,
        awardPerfil: {
          laboralsLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formEditLaboral([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const deleteLaboral = (uid, index, values) => (dispatch) => {
  return new Promise((resolve, reject) => {
    if (values[index].myImageCert) {
      deleteImg(uid, values[index].myImageCert);
    }
    let LaboralElems = values.filter(function (Element, ind) {
      return index !== ind;
    });

    let boolValues
    LaboralElems.forEach((elem) => {
      const allValues = Object.values(elem)
      boolValues = allValues.every(elem => {
        if (elem !== '') {
          return true
        }
        return false
      })
    })

    if (!LaboralElems || LaboralElems.length === 0) {
      LaboralElems = []
      boolValues = false
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        laboralsLawyer: LaboralElems,
        awardPerfil: {
          laboralsLawyer: boolValues,
        }
      }, { merge: true })
      .then((res) => {
        dispatch(formDeleteLaboral(LaboralElems, boolValues));
        return resolve(true);
      })
      .catch((error) => reject(false));

  });
};

/* ------------------------------------------------------------------------------------------ */

export const addCertification = (uid, values, certificationsLawyer, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {

    let updatedData
    if (certificationsLawyer && certificationsLawyer.length !== 0) {
      updatedData = [
        ...values,
        ...certificationsLawyer,
      ]
    } else {
      updatedData = [
        ...values,
      ]
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        certificationsLawyer: updatedData,
        awardPerfil: {
          certificationsLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formAddCertification([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const editCertification = (
  uid,
  values,
  certificationsLawyer,
  boolValues,
) => (dispatch) => {
  return new Promise((resolve, reject) => {

    let updatedData = [
      ...certificationsLawyer,
      ...values
    ]

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        certificationsLawyer: updatedData,
        awardPerfil: {
          certificationsLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formEditCertification([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const deleteCertification = (uid, index, values) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    if (values[index].myImageCert) {
      deleteImg(uid, values[index].myImageCert);
    }

    let CertificationElems = values.filter(function (Element, ind) {
      return index !== ind;
    });

    let boolValues
    CertificationElems.forEach((elem) => {
      const allValues = Object.values(elem)
      boolValues = allValues.every(elem => {
        if (elem !== '') {
          return true
        }
        return false
      })
    })

    if (!CertificationElems || CertificationElems.length === 0) {
      CertificationElems = []
      boolValues = false
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        certificationsLawyer: CertificationElems,
        awardPerfil: {
          certificationsLawyer: boolValues,
        }
      }, { merge: true })
      .then((res) => {
        dispatch(formDeleteCertification(CertificationElems, boolValues));
        return resolve(true);
      })
      .catch((error) => reject(false));

  });
};

/* ------------------------------------------------------------------------------------------ */

export const addPublication = (uid, values, publicationsLawyer, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {

    let updatedData
    if (publicationsLawyer && publicationsLawyer.length !== 0) {
      updatedData = [
        ...values,
        ...publicationsLawyer,
      ]
    } else {
      updatedData = [
        ...values,
      ]
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        publicationsLawyer: updatedData,
        awardPerfil: {
          publicationsLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formAddPublication([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const editPublication = (
  uid,
  values,
  publicationsLawyer,
  boolValues,
) => (dispatch) => {
  return new Promise((resolve, reject) => {

    let updatedData = [
      ...publicationsLawyer,
      ...values
    ]

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        publicationsLawyer: updatedData,
        awardPerfil: {
          publicationsLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formEditPublication([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const deletePublication = (uid, index, values) => (dispatch) => {
  return new Promise((resolve, reject) => {
    if (values[index].myImageCert) {
      deleteImg(uid, values[index].myImageCert);
    }
    let PublicationElems = values.filter(function (Element, ind) {
      return index !== ind;
    });

    let boolValues
    PublicationElems.forEach((elem) => {
      const allValues = Object.values(elem)
      boolValues = allValues.every(elem => {
        if (elem !== '') {
          return true
        }
        return false
      })
    })

    if (!PublicationElems || PublicationElems.length === 0) {
      PublicationElems = []
      boolValues = false
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        publicationsLawyer: PublicationElems,
        awardPerfil: {
          publicationsLawyer: boolValues,
        }
      }, { merge: true })
      .then((res) => {
        dispatch(formDeletePublication(PublicationElems, boolValues));
        return resolve(true);
      })
      .catch((error) => reject(false));

  });
};

/* ------------------------------------------------------------------------------------------ */

export const addSpecialty = (uid, data, boolValues) => dispatch => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        specialties: data.spe,
        subSpecialities: data.sub,
        extraSubSpecialities: data.extra, 
        awardPerfil: {
          specialties: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formAddSpecialty(data, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const editSpecialty = (uid, data, boolValues) => dispatch => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        specialties: data.spe,
        subSpecialities: data.sub,
        extraSubSpecialities: data.extra,
        awardPerfil: {
          specialties: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formEditSpecialty(data, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const deleteSpecialty = (uid, data, boolValues) => dispatch => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        specialties: data.spe,
        subSpecialities: data.sub,
        extraSubSpecialities: data.extra,
        awardPerfil: {
          specialties: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formDeleteSpecialty(data, boolValues));
        return resolve(true);
      })
      .catch((error) => reject(false));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const addHolderFirm = (uid, values, allHolders, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {
    let updatedData = firebase.firestore.FieldValue.arrayUnion({
      ...values,
    });
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        holders: updatedData,
        awardPerfil: {
          holder: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        let arrFinal;
        arrFinal = allHolders && allHolders.concat({
          ...values,
        });
        dispatch(formAddHolder(arrFinal, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const editHolderFirm = (
  uid,
  values,
  item,
  allHolders,
  boolValues,
) => (dispatch) => {
  return new Promise((resolve, reject) => {
    var newHoldersElem = allHolders.filter(function (Element, index) {
      return index !== item;
    });

    const deletedHolders = firebase.firestore.FieldValue.delete();

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .update({ holders: deletedHolders })
      .then((res) => { });

    newHoldersElem.map((item, index) => {
      let updatedHolders = firebase.firestore.FieldValue.arrayUnion({
        ...item,
      });

      firestore
        .collection('lawyerUsers')
        .doc(uid)
        .set({
          holders: updatedHolders,
        }, { merge: true })
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => reject(err));
    });

    let updatedData = '';
    updatedData = firebase.firestore.FieldValue.arrayUnion({ ...values });

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        holders: updatedData,
        awardPerfil: {
          holder: boolValues
        }
      }, { merge: true })
      .then((res) => {
        let arrFinal;
        arrFinal = newHoldersElem.concat(values);
        dispatch(formEditHolder(arrFinal, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const deleteHolderFirm = (uid, item, allHolders) => (dispatch) => {
  return new Promise(async (resolve, reject) => {

    const deleteImgProfile = await deleteImageProfile(allHolders[item].imgProfileHolder);
    const deleteImgArrayCert = await deleteArrayImage(allHolders[item].certifications);
    const deleteImgArrayAward = await deleteArrayImage(allHolders[item].awards);

    await Promise.all([
      deleteImgProfile,
      deleteImgArrayCert,
      deleteImgArrayAward,
    ])

    let HolderElems = allHolders.filter(function (Element, index) {
      return index !== item;
    });

    let boolValues = HolderElems.every(item => {
      if (item === 0) {
        return false
      } else {
        const values = Object.values(item)
        const bool = values.every(elem => {
          return elem
        })
        return bool
      }
    })

    if (HolderElems.length === 0) {
      boolValues = false
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        holders: HolderElems,
        awardPerfil: {
          holder: boolValues,
        }
      }, { merge: true })
      .then((res) => {
        dispatch(formDeleteHolder(HolderElems, boolValues));
        return resolve(true);
      })
      .catch((error) => reject(false));

  });
};




export const addHolderPremium = (
  uid,
  itemArr,
  email,
  allHolders,
  data
) => (dispatch) => {
  return new Promise((resolve, reject) => {
  
  let wholeArr =[];
    const deletedHolders = firebase.firestore.FieldValue.delete();

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .update({ holders: deletedHolders })
      .then((res) => { });


   allHolders.map((item, index) => {
        if(index == itemArr){
          wholeArr.push({ ...item,
            lawyerPremium: true})
           
        }else{
          wholeArr.push(item)
        }
    });

   
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        holders: wholeArr,
      }, { merge: true })
      .then((res) => {
        
        dispatch(formTitularPremium(wholeArr ,email, data));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};


/* ------------------------------------------------------------------------------------------ */

export const addLawyerFirm = (uid, values, allLayers, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {

    const updatedData = firebase.firestore.FieldValue.arrayUnion({
      ...values,
    });

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        lawyers: updatedData,
        awardPerfil: {
          collaborators: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        let arrFinal;
        arrFinal = allLayers && allLayers.concat({ ...values });
        dispatch(formAddLawyer(arrFinal, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const editLawyerFirm = (
  uid,
  values,
  item,
  allLayers,
  boolValues,
) => (dispatch) => {
  return new Promise((resolve, reject) => {
    var newLawyerElem = allLayers.filter(function (Element, index) {
      return index !== item;
    });

    const deletedLawyers = firebase.firestore.FieldValue.delete();

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .update({ lawyers: deletedLawyers })
      .then((res) => { });

    newLawyerElem.map((item, index) => {
      let updatedLawyers = firebase.firestore.FieldValue.arrayUnion({
        ...item,
      });

      firestore
        .collection('lawyerUsers')
        .doc(uid)
        .set({
          lawyers: updatedLawyers,
        }, { merge: true })
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => reject(err));
    });

    let updatedData = '';
    updatedData = firebase.firestore.FieldValue.arrayUnion({ ...values });

    firestore
      .collection('lawyerUsers')
      .doc(uid) //.set({ lawyers: [{ ...values, imgProfile }] }, { merge: true })
      .set({
        lawyers: updatedData,
        awardPerfil: {
          collaborators: boolValues
        }
      }, { merge: true })
      .then((res) => {
        let arrFinal;
        arrFinal = newLawyerElem.concat(values);
        dispatch(formEditLawyer(arrFinal, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* ------------------------------------------------------------------------------------------ */

export const deleteLawyerFirm = (uid, item, allLayers) => (dispatch) => {
  return new Promise(async (resolve, reject) => {

    const deleteImgProfile = await deleteImageProfile(allLayers[item].imgProfileLawyer);
    await Promise.all([deleteImgProfile])

    let LawyerElems = allLayers.filter(function (Element, index) {
      return index !== item;
    });

    let boolValues = LawyerElems.every(item => {
      if (item === 0) {
        return false
      } else {
        const values = Object.values(item)
        const bool = values.every(elem => {
          return elem
        })
        return bool
      }
    })

    if (LawyerElems.length === 0) {
      boolValues = false
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        lawyers: LawyerElems,
        awardPerfil: {
          collaborators: boolValues,
        }
      }, { merge: true })
      .then((res) => {
        dispatch(formDeleteLawyer(LawyerElems, boolValues));
        return resolve(true);
      })
      .catch((error) => reject(false));
  });
};

/* ------------------------------------------------------------------------------------------ */

/* Delete Images */

const deleteArrayImage = async (array) => {
  return new Promise(async (resolve, reject) => {
    const data = array.map(async (elem) => {
      let pathImg = {
        cert: '',
        award: '',
      }
      if (elem.myImageCert && elem.myImageCert.includes('firebase')) {
        pathImg['cert'] = elem.myImageCert
      }
      if (elem.myImageAward && elem.myImageAward.includes('firebase')) {
        pathImg['award'] = elem.myImageAward
      }
      if (pathImg.cert) {
        try {
          const deletePromise = await storage
            .refFromURL(pathImg.cert)
            .delete()
          return deletePromise
        } catch (error) {
          return reject()
        }
      }
      if (pathImg.award) {
        try {
          const deletePromise = await storage
            .refFromURL(pathImg.award)
            .delete()
          return deletePromise
        } catch (error) {
          return reject()
        }
      }
    })
    try {
      const res = await Promise.all(data)
      resolve(res)
    } catch (error) {
      return reject(error)
    }
  });
};

const deleteImageProfile = (pathImg) => {
  return new Promise((resolve, reject) => {
    if (pathImg) {
      try {
        const response = storage
          .refFromURL(pathImg)
          .delete()
        return resolve(response)
      } catch (error) {
        return reject(error);
      }
    } else {
      resolve()
    }
  });
};

export const deleteImg = (uid, pathImg) => {
  return new Promise((resolve, reject) => {
    // Create a reference to the file to delete
    let desertRef = storage.refFromURL(pathImg);
    // Delete the file
    desertRef
      .delete()
      .then((res) => {
        // File deleted successfully
        return resolve(res);
      })
      // Uh-oh, an error occurred!
      .catch((err) => {
        return reject(err);
      });
  });
};



export const getMembershipData = (idStripe, idFactura) => async (dispatch) => {




  let payments = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/viewChargesCustomer?id=${idStripe}`, {
    headers: {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
    }
  }).then(res => {
    return res.data.data
  })
    .catch(err => {
      return []
    });

  let cards = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/viewListCardClient?id=${idStripe}`, {
    headers: {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
    }
  }).then(res => {
    return res.data.data
  })
    .catch(err => {
      return []
    });
  let invoices = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/invoices/get_all_invoice_client?idInvoice=${idFactura}`, {
    headers: {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
    }
  }).then(res => {
    return res.data.data
  })
    .catch(err => {
      return []
    });

  dispatch(membershipData({ payments: payments, cards: cards, invoices, idStripe, idFactura }))
}




/* ------------------------------------------------------------------------------------------ */

export const addVideoYoutube = (values, uid, boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const updatedVideos = firebase.firestore.FieldValue.arrayUnion(values);
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        videosYoutube: updatedVideos,
        awardAditional: {
          videos: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formVideoYoutube({ ...values }, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const deleteVideoYoutube = (newVideoElem, uid, idImage, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        videosYoutube: newVideoElem,
        awardAditional: {
          videos: boolValues
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formDeleteVideoYoutube(newVideoElem, boolValues));
        resolve(res);
      });


  });
};

export const setShareTrophie = (uid, boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        awardAditional: {
          shareProfile: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(shareTrophie(boolValues))
        return resolve(res);
      })
      .catch((err) => reject(err))
  })
}

export const addSite = (uid, values, sede = '', boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const updatedSedes = firebase.firestore.FieldValue.arrayUnion(values);
    const updatedState = firebase.firestore.FieldValue.arrayUnion(values.estado);



    /* const validSites = sede.every(item => {
      const values = Object.values(item)
      console.log('values valiSItes', values)
      const bool = values.every(elem => elem)
     return bool
   })
   console.log('validSites', validSites) */

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        sede: updatedSedes,
        states: updatedState,
        awardPerfil: {
          site: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(sedeProfile([...sede, { ...values }], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* Editar Sedes --------------------------------------------------------------*/

export const editSite = (uid, item, values, arrSedeAll, boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {
    var newSedeElem = arrSedeAll.filter(function (sedeItem, index) {
      return item !== index;
    });

    //Validando si las sedes anteriores son validas para obtener el logro
    /* const validSites = newSedeElem.every(item => {
      const valuesItem = Object.values(item)
      const bool = valuesItem.every(elem => elem )
     return bool
   }) */


    //si la sede en edicion tiene todos los datos y las otras sedes también, entonces award = true
    let award = boolValues;

    // ELiminamos los elementos existentes
    const deletedSedes = firebase.firestore.FieldValue.delete();
    const deletedState = firebase.firestore.FieldValue.delete();

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .update({ sede: deletedSedes, states: deletedState })
      .then((res) => { });

    // Agregamos los elementos que no tuvieron cambios
    newSedeElem.map((item, index) => {
      let updatedSede = firebase.firestore.FieldValue.arrayUnion({
        direccion: item.direccion,
        estado: item.estado,
        municipio: item.municipio,
        //phone: item.phone,
      });

      let updatedstate = firebase.firestore.FieldValue.arrayUnion(item.estado
      );

      firestore
        .collection('lawyerUsers')
        .doc(uid)
        .set({ sede: updatedSede, states: updatedstate }, { merge: true })
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => reject(err));
    });

    newSedeElem.push({
      direccion: values.direccion,
      estado: values.estado,
      municipio: values.municipio,
      //phone: values.phone,
    });

    const updatedSedes = firebase.firestore.FieldValue.arrayUnion({
      direccion: values.direccion,
      estado: values.estado,
      municipio: values.municipio,
      //phone: values.phone,
    });

    const updatedStates = firebase.firestore.FieldValue.arrayUnion(
      values.estado
    );

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        sede: updatedSedes,
        states: updatedStates,
        awardPerfil: {
          site: award
        }
      }, { merge: true })
      .then((res) => {
        //dispatch(sedeProfileEdit({ ...values }));
        dispatch(sedeProfileEdit(newSedeElem, award));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* --------------------------------------------------------------------------------------- */

export const deleteSedeStore = (uid, item, allSedes) => (dispatch) => {
  return new Promise((resolve, reject) => {
    //Filtramos el elemento a borrar
    let deleteSedeElem = allSedes.filter(function (Element, index) {
      return index === item;
    });

    //Borramos la imagen del elemento
    /* deleteSedeElem.map((item, index) => {
      if (item.imgProfile != '') {
        deleteImg(uid, item.imgProfile);
      }
      ///
    });
 */
    //Elementos que no se eliminaran
    let newSedeElem = allSedes.filter(function (Element, index) {
      return index !== item;
    });

    const validSites = newSedeElem.every(item => {
      const values = Object.values(item)
      const bool = values.every(elem => elem)
      return bool
    })
    const boolValues = newSedeElem.length > 0 && validSites === true ? true : false;


    const deletedSedesItems = firebase.firestore.FieldValue.delete();
    const deletedSedesState = firebase.firestore.FieldValue.delete();


    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .update({ sede: deletedSedesItems, states: deletedSedesState })
      .then((res) => { });

    //Agregamos los elementos restantes
    if (newSedeElem.length > 0) {
      newSedeElem.map((item, index) => {
        let updatedSedes = firebase.firestore.FieldValue.arrayUnion({
          ...item,
        });
        let updatedState = firebase.firestore.FieldValue.arrayUnion(
          item.estado,
        );
        firestore
          .collection('lawyerUsers')
          .doc(uid)
          .set({
            sede: updatedSedes,
            states: updatedState,
            awardPerfil: {
              site: boolValues,
            }
          }, { merge: true })
          .then((res) => {
            dispatch(formDeleteSede(newSedeElem, boolValues));
            return resolve(res);
          })
          .catch((err) => reject(err));
      });
    } else {
      firestore
        .collection('lawyerUsers')
        .doc(uid)
        .set({
          awardPerfil: {
            site: false,
          }
        }, { merge: true })
        .then((res) => {
          dispatch(formDeleteSede([], false));
          return resolve(true);
        })
        .catch((err) => reject(err));
    }
  });
};
/* --------------------------------------------------------------------------------------- */

export const addinfoProfile = (uid, values, boolValues) => (dispatch) => {
  let {
    phone = '',
    movil = '',
    whats = '',
    email = '',
    blog = '',
    // laborDays = '',
    // dayStart = '',
    // dayEnd = '',
    // linkedIn = '',
  } = values;
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        contacto: {
          phone,
          movil,
          whats,
          email,
          blog,
          // laborDays,
          // dayStart,
          // dayEnd,
          // linkedIn,
        },
        awardPerfil: {
          contact: boolValues
        },
      },
        { merge: true })
      .then((res) => {
        dispatch(
          aditionProfile({
            phone,
            movil,
            whats,
            email,
            blog,
            // laborDays,
            // dayStart,
            // dayEnd,
            // linkedIn,
          }, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const addSocialNetworksProfile = (uid, values, boolValues) => (dispatch) => {
  let {
    linkedIn = '',
    twitter = '',
    facebook = '',
    instagram = '',
    youtube = '',
  } = values;
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        socialNetworks: {
          linkedIn,
          twitter,
          facebook,
          instagram,
          youtube,
        },
        awardPerfil: {
          socialNetworks: boolValues
        },
      },
        { merge: true })
      .then((res) => {
        dispatch(
          addSocialNetworks({
            linkedIn,
            twitter,
            facebook,
            instagram,
            youtube,
          }, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

/* 
export const addinfoProfile = (uid, values) => dispatch => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({ contacto: [{ ...values }] }, { merge: true })
      .then(res => {
        dispatch(aditionProfile({ ...values }));
        return resolve(res);
      })
      .catch(err => reject(err));
  });
};
 */

export const addCost = (uid, values, boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        cost: { ...values },
        awardAditional: {
          cost: boolValues,
        }
      }, { merge: true })
      .then((res) => {
        dispatch(costProfile({ ...values }, boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

// Notifications
export const markedReaded = (uid, read, array, uidLawyer, notificationUserType) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let actualReaded = !read;

    let newData = array.map((el) => {

      if (el.uid == uid) {
        el['read'] = !el.read;
        //return Object.assign({}, el, { read: !el.read });

      }
      return el;

    });

    firestore
      .collection(notificationUserType)
      .doc(uidLawyer)
      .collection('notification')
      .doc(uid)
      .update({ read: actualReaded })
      .then((res) => {
        dispatch(notificationReaded(newData));
        //process_notificationsPage(dispatch, uidLawyer, 1, 'lawyer')
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const markedFeatured = (uid, featured, array, uidLawyer) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let actualFeatured = !featured;
    // Update Array  with object
    let newData = array.map((el) => {
      if (el.uid == uid)
        return Object.assign({}, el, { featured: !el.featured });
      return el;
    });
    firestore
      .collection('notifications')
      .doc(uidLawyer)
      .collection('notification')
      .doc(uid)
      .update({ featured: actualFeatured })
      .then((res) => {
        dispatch(notificationReaded(newData));
        //process_notificationsPage(dispatch, uidLawyer, 1, 'lawyer')
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const deleteNotification = (uid, array, uidLawyer) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // find item on  Array  with object
    let newData = array.filter((el) => el.uid != uid);

    firestore
      .collection('notifications')
      .doc(uidLawyer)
      .collection('notification')
      .doc(uid)
      .delete()
      .then((res) => {
        process_notificationsPage(dispatch, uidLawyer, 1, 'lawyer')
        //dispatch(notificationReaded(newData));
        return resolve(res);

      })
      .catch((err) => reject(err));
  });
};

export const resetNewNotifications = (uidLawyer, profile) => (dispatch) => {
  return new Promise((resolve, reject) => {

    firestore
      .collection('lawyerUsers')
      .doc(uidLawyer)
      .update({ newNotifications: 0 })
      .then((res) => {
        dispatch(notificationRestarted(0));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};
/////


/// Notifications Lawyer
export const setNotificationRead = (notification, menuNotifications, pageNotifications, allNotifications) => (dispatch) => {
  return new Promise((resolve, reject) => {    
    // Update Array  with object
    let readState = !notification.read;
    console.log('notification', notification);
    // let uid = element && element.role === "lawyer" && element.idLawFirm && element.idLawFirm !== undefined ? element.idLawFirm : user.uid;
    const uidLawyer = notification.idNotifications ? notification.idNotifications : notification.lawyerUid;

    let getNewData = (array) => (
      array.map((el) => {

        if (el.uid == notification.uid) {
          el['read'] = !el.read;
          //return Object.assign({}, el, { read: !el.read });
  
        }
        return el;
  
      })
    )
      //console.log('pageNotifications', pageNotifications)
    const notificationInMenu = menuNotifications && menuNotifications.map((item) => (item.uid === notification.uid));

    const notificationInPage = pageNotifications && pageNotifications.map((item) => (item.uid === notification.uid))

    const notificationInList = allNotifications && allNotifications.map((item) => (item.uid === notification.uid))

    console.log('uidLawyer', uidLawyer);

    firestore
      .collection('notifications')
      .doc(uidLawyer)
      .collection('notification')
      .doc(notification.uid)
      .update({ read: readState })
      .then((res) => {
        notificationInMenu && dispatch(updateLawyerMenuNotifications(getNewData(menuNotifications)));
        notificationInPage && dispatch(updateLawyerPageNotifications(getNewData(pageNotifications)));
        notificationInList && dispatch(updateNotificationsLaw(getNewData(allNotifications)));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const setNotificationFeatured = (notification, menuNotifications, pageNotifications) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let actualFeatured = !notification.featured;
    const uidLawyer = notification.idNotifications ? notification.idNotifications : notification.lawyerUid;
    // Update Array  with object
    let getNewData = (array) => (
      array.map((el) => {
        if (el.uid == notification.uid)
          return Object.assign({}, el, { featured: !el.featured });
        return el;
      })
    )

    const notificationInMenu = menuNotifications.map((item) => (item.uid === notification.uid));

    const notificationInPage = pageNotifications.map((item) => (item.uid === notification.uid))
    firestore
      .collection('notifications')
      .doc(uidLawyer)
      .collection('notification')
      .doc(notification.uid)
      .update({ featured: actualFeatured })
      .then((res) => {
        notificationInMenu && dispatch(updateLawyerMenuNotifications(getNewData(menuNotifications)));
        notificationInPage && dispatch(updateLawyerPageNotifications(getNewData(pageNotifications)));
        
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const deleteLawyerNotification = (notification, menuNotifications, pageNotifications, allNotifications) => (dispatch) => {
  return new Promise((resolve, reject) => {

    const uidLawyer = notification.idNotifications ? notification.idNotifications : notification.lawyerUid;
    
    // find item on  Array  with object
    //let newData = array.filter((el) => el.uid != uid);
    let getNewData = (array) => (array.filter((el) => el.uid !== notification.uid))

    const notificationInMenu = menuNotifications.map((item) => (item.uid === notification.uid));

    const notificationInPage = pageNotifications.map((item) => (item.uid === notification.uid));

    const notificationInList = allNotifications && allNotifications.map((item) => (item.uid === notification.uid));

    firestore
      .collection('notifications')
      .doc(uidLawyer)
      .collection('notification')
      .doc(notification.uid)
      .delete()
      .then((res) => {
        notificationInMenu && dispatch(updateLawyerMenuNotifications(getNewData(menuNotifications)));
        notificationInPage && dispatch(updateLawyerPageNotifications(getNewData(pageNotifications)));
        notificationInList && dispatch(updateNotificationsLaw(getNewData(allNotifications)));
        return resolve(res);

      })
      .catch((err) => reject(err));
  });
};


//// Messages
export const deleteMessage = (uid, array, userUid) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // For Storage

    let newData = array.filter((el) => el.uid != uid);
    //For Firebase
    firestore
      .collection('messages')
      .doc(userUid)
      .collection('message')
      .doc(uid)
      .delete()
      .then((res) => {
        // send to storage
        dispatch(messageDeleted(newData));
        return resolve(res);
      })
      .catch((err) => reject(err));
    return null;
  });
};


export const readMessage = (uid, array, userUid) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // For Storage
    let newData = array.map((el, indexNew) => {
      if (el.uid == uid)
        return Object.assign({}, el, {
          read: true,
        })

      return el;
    });

    console.log('uid', uid);

    firestore
      .collection('messages')
      .doc(userUid)
      .collection('message')
      .doc(uid)
      .update({ 'read': true })
      .then((res) => {
        dispatch(messageReaded(newData));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const saveMessage = (uid, array, userUid) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let newData = array.map((el) => {
      if (el.uid == uid) return Object.assign({}, el, { save: true });
      return el;
    });
    firestore
      .collection('messages')
      .doc(userUid)
      .collection('message')
      .doc(uid)
      .set({ save: true }, { merge: true })
      .then((res) => {
        
        dispatch(messageSaved(newData));
        return resolve(res);
      })
      .catch((err) => {
      
        console.log(err)

        reject(err)});
  });
};

// Contacts
export const unsetSaved = (uid, save, array, userUid) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let actualSave = !save;
    // For Storage
    let newData = array.map((el) => {
      if (el.uid == uid) return Object.assign({}, el, { save: !el.save });
      return el;
    });

    firestore
      .collection('messages')
      .doc(userUid)
      .collection('message')
      .doc(uid)
      .update({ save: actualSave })
      .then((res) => {
        dispatch(contactDeleted(newData));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

// Opinions
export const deleteOpinion = (uid, array, uidAuth, page) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // For Storage


    let newData = array.data.filter(elem => elem.uid !== uid)


    let request = firestore
      .collection('opinions')
      .doc(uidAuth)
      .collection('opinion')
      .doc(uid)
      // .delete()
      .update({ visible: false })
    return request.then(async (res) => {
      // send to storage
      try {
        await process_opinionsPage(dispatch, uidAuth, 1, resolve)
        return resolve()
      } catch (error) {
        return reject()
      }
    })
      .catch((err) => reject(err));
    // return null;
  });
};

export const updateSchedule = (uid, values, boolValues, typeSchedule) => (dispatch) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .update({
        "schedule": {
          type: typeSchedule,
          scheduleDays: { ...values }
        }
      })
      .then((res) => {
        dispatch(saveSchedule({ ...values }, boolValues, typeSchedule));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const addSchedule = (uid, values, boolValues, typeSchedule) => (dispatch) => {
  return new Promise((resolve, reject) => {
    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        schedule: {
          type: typeSchedule,
          scheduleDays: { ...values }
        },
        awardPerfil: {
          schedule: boolValues
        }
      }, { merge: true })
      .then((res) => {
        dispatch(saveSchedule({ ...values }, boolValues, typeSchedule));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};

export const deleteSchedule = (uid, boolValues) => (dispatch) => {
  return new Promise((resolve, reject) => {

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        schedule: [],
        awardPerfil: {
          schedule: boolValues
        }
      }, { merge: true })
      .then((res) => {
        dispatch(scheduleDeleted([], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));
    //update({ schedule: firebase.firestore.FieldValue.delete() })
  });
};

/* ---------------------------------------------------------------------------------------------- */
//EDUCATION
export const addEducation = (uid, values, educationLawyer, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {

    //console.log('formValues', values)

    let updatedData
    if (educationLawyer && educationLawyer.length !== 0) {
      updatedData = [
        ...values,
        ...educationLawyer,
      ]
    } else {
      updatedData = [
        ...values,
      ]
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        educationLawyer: updatedData,
        awardPerfil: {
          educationLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formEducationLawyer([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));

  });
};

export const editEducation = (uid, values, educationLawyer, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {

    let updatedData = [
      ...educationLawyer,
      ...values
    ]

    //console.log('updatedData', updatedData)
    //console.log('values action', values.educationLawyer)

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        educationLawyer: updatedData,
        awardPerfil: {
          educationLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formEditEducation([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));

  });
};

export const deleteEducationItem = (uid, index, values) => (dispatch) => {
  return new Promise((resolve, reject) => {

    let EducationElems = values.filter(function (Element, ind) {
      return index !== ind;
    });

    let boolValues
    EducationElems.forEach((elem) => {
      const allValues = Object.values(elem)
      boolValues = allValues.every(elem => {
        if (elem !== '') {
          return true
        }
        return false
      })
    })

    if (!EducationElems || EducationElems.length === 0) {
      EducationElems = []
      boolValues = false
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        educationLawyer: EducationElems,
        awardPerfil: {
          educationLawyer: boolValues,
        }
      }, { merge: true })
      .then((res) => {
        dispatch(formDeleteEducationItem(EducationElems, boolValues));
        return resolve(true);
      })
      .catch((error) => reject(false));

  });
};

/* ---------------------------------------------------------------------------------------------- */
//COURSES LAWYER

export const addCourses = (uid, values, coursesLawyer, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {

    //console.log('formValues', values)

    let updatedData
    if (coursesLawyer && coursesLawyer.length !== 0) {
      updatedData = [
        ...values,
        ...coursesLawyer,
      ]
    } else {
      updatedData = [
        ...values,
      ]
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        coursesLawyer: updatedData,
        awardAditional: {
          coursesLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formCoursesLawyer([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));

  });
};

export const editCourses = (uid, values, coursesLawyer, boolValues) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {

    let updatedData = [
      ...coursesLawyer,
      ...values
    ]

    //console.log('updatedData', updatedData)
    //console.log('values action', values.coursesLawyer)

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        coursesLawyer: updatedData,
        awardAditional: {
          coursesLawyer: boolValues,
        },
      }, { merge: true })
      .then((res) => {
        dispatch(formEditCourses([...updatedData], boolValues));
        return resolve(res);
      })
      .catch((err) => reject(err));

  });
};

export const deleteCoursesItem = (uid, index, values) => (dispatch) => {
  return new Promise((resolve, reject) => {

    let CoursesElems = values.filter(function (Element, ind) {
      return index !== ind;
    });

    let boolValues
    CoursesElems.forEach((elem) => {
      const allValues = Object.values(elem)
      boolValues = allValues.every(elem => {
        if (elem !== '') {
          return true
        }
        return false
      })
    })

    if (!CoursesElems || CoursesElems.length === 0) {
      CoursesElems = []
      boolValues = false
    }

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        coursesLawyer: CoursesElems,
        awardAditional: {
          coursesLawyer: boolValues,
        }
      }, { merge: true })
      .then((res) => {
        dispatch(formDeleteCoursesItem(CoursesElems, boolValues));
        return resolve(true);
      })
      .catch((error) => reject(false));

  });
};



export const setMemeshipInfo = (uid, values,) => (dispatch) => {
  return new Promise((resolve, reject) => {

    const createAt = new Date();

    firestore
      .collection('lawyerUsers')
      .doc(uid)
      .set({
        membership: {
          type: "Premium",
          timeMembership: createAt,
          status: 'active',
          gift: '',
          typePayment: values.typePayment,
          cost: values.cost
        }
      }, { merge: true })
      .then((res) => {
        dispatch(membershipInfo({
          type: "Premium",
          timeMembership: createAt,
          status: 'active',
          gift: '',
          typePayment: values.typePayment,
          cost: values.cost
        }));
        return resolve(res);
      })
      .catch((err) => reject(err));
  });
};


// Falta proceso cuando no es cliente y no tiene idstripe
export const addCard = (card, billing) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/createToken`, card, {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
      }
    }).then(res => {
      if (res.data.id) {
        axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/createCardByClient`,
          {
            clientId: billing.idStripe,
            tokenCard: res.data.id
          },
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
            }
          }).then(response => {
            dispatch(addNewCard(response.data))
            return resolve(response);
          })
          .catch(err => {
            return reject(err)
          });
      } else if (res.data.error.code == 'invalid_number') {
        return reject('Datos incorrectos de tarjeta')
      }
    }).catch(error => {
      return reject('Intente mas tarde')
    });
  })
}

export const updateDefaultCard = (idCard, billing) => (dispatch) => {
  return new Promise((resolve, reject) => {


    axios.put(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/updateDefaultCard?clientId=${billing.idStripe}&idCard=${idCard}`,
      {
        headers: {
          'Content-Type': 'text/plan',
          "Access-Control-Allow-Origin": "*",
          'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
        }
      }).then(res => {

        return resolve(res);
      }).catch(error => {
        return reject('error')
      });
  })
}

export const deleteCard = (idCard, billing) => (dispatch) => {
  return new Promise((resolve, reject) => {
    var data = JSON.stringify({ "clientId": billing.idStripe, "idCard": idCard });
    var config = {
      method: 'delete',
      url: `${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/deleteCard`,
      headers: {
        'Authorization': 'Bearer TgC1n73rN37Gr0u9',
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios(config)
      .then(res => {
        return resolve(res);
      }).catch(error => {
        return reject('error')
      });
  })
}

export const setLocation = (location) => dispatch => {
  return new Promise(async (resolve, reject) => {
    const paramsLawyer = {
      role: 'lawyer',
      state: location,
    };
    const paramsLawFirm = {
      role: 'lawFirm',
      state: location,
    };
    dispatch(browserLocation(location));
    try {
      const landingLawyers = await getLawyersLanding(paramsLawyer)
      const landingLawFirms = await getLawyersLanding(paramsLawFirm)
      dispatch(browserLandingLawyers({
        lawyers: landingLawyers &&
          landingLawyers.length &&
          landingLawyers.length !== 0 ?
          landingLawyers : [],
        lawfirms: landingLawFirms &&
          landingLawFirms &&
          landingLawFirms.length &&
          landingLawFirms.length !== 0 ?
          landingLawFirms : []
      }))
      return resolve('success');
    } catch (error) {
      console.log('error', error);
      return reject('error');
    }
  });
}

